module.exports = __webpack_public_path__ + "static/media/043.eb6d114e.png";